<template>
	<div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true"
		style="overflow: hidden;">
		<div class="m-portlet m-portlet--mobile">
			<PageHead label='请假管理' label2="新增请假记录" url="/cycle/leave/list"></PageHead>
			<!-- <PageHead label='请假管理' label2="新增请假记录" label3="Tips：请假超过13天需变更学员轮转状态，结业时需补足轮转时间" url="/cycle/leave/list"></PageHead> -->
			<el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed">
				<div class="m-portlet__body">
					<el-row style="font-size: 16px; margin: 15px 30px 0 30px;">
						<el-col :span="24">选择学员</el-col>
					</el-row>
					<div class="form-group m-form__group row">
						<label class="col-xl-2 col-form-label">姓名：</label>
						<div class="col-xl-2">
							<el-input v-model="condition.stuname" placeholder="姓名" @blur="SearchStu"></el-input>
						</div>
						<label class="col-xl-1 col-form-label">工号：</label>
						<div class="col-xl-2">
							<el-input v-model="condition.stuno" placeholder="工号" @blur="SearchStu"></el-input>
						</div>
						<label class="col-xl-1 col-form-label">请假人：</label>
						<div class="col-xl-2">
							<el-select v-model="form.leavestu" filterable placeholder="请选择" @change="StuSelect">
								<el-option label="请选择" value=""></el-option>
								<el-option v-for="item in stuOptions" :key="item.StuID" :label="item.StuName"
									:value="item.StuID">
								</el-option>
							</el-select>
						</div>
					</div>
				</div>
				<div class="m-portlet__body" v-if="selectstate == true">
					<el-row style="font-size: 16px; margin: 15px 30px 0 30px;">
						<el-col :span="24">当前选择学员</el-col>
					</el-row>
					<el-row style="font-size: 14px;margin: 15px 0;">
						<el-col :span="3" style="text-align: right;">
							姓名：
						</el-col>
						<el-col :span="3">{{selectstuname}}</el-col>
						<el-col :span="2" style="text-align: right;">工号：</el-col>
						<el-col :span="3">{{selectstuno}}</el-col>
						<el-col :span="2" style="text-align: right;">当前管理单元：</el-col>
						<el-col :span="3">{{selectstumanagesec}}</el-col>
						<el-col :span="2" style="text-align: right;">当前轮转科室：</el-col>
						<el-col :span="3">{{selectstucpsec}}</el-col>
					</el-row>
					<el-row style="font-size: 16px; margin: 15px 30px 0 30px;">
						<el-col :span="24">历史请假记录</el-col>
					</el-row>
					<div style="margin: 15px 30px 0 30px;">
						<el-table v-loading="ldloading" :data="ldTableData" stripe style="width: 100%;" size="medium">
							<el-table-column prop="CPSecName" label="请假科室">
							</el-table-column>
							<el-table-column label="请假时间">
								<template slot-scope="scope">
									{{scope.row.BeginDate|formatDate}}<br>{{scope.row.EndDate|formatDate}}
								</template>
							</el-table-column>
							<el-table-column prop="LeaveDay" label="请假天数">
							</el-table-column>
							<el-table-column prop="LeaveTypeName" label="请假类型">
							</el-table-column>
						</el-table>
					</div>
					<div style="margin-top: 10px;text-align: center;" v-if="this.ldcondition.recordCount > 0">
						<el-pagination @size-change="ldhandleSizeChange" @current-change="ldhandleCurrentChange"
							:current-page="ldcondition.currentPage" :page-sizes="[5, 10, 20, 30, 40]"
							:page-size="ldcondition.pageSize" layout="total, sizes, prev, pager, next, jumper"
							:total="ldcondition.recordCount">
						</el-pagination>
					</div>
					<el-row style="font-size: 16px; margin: 15px 30px 0 30px;">
						<el-col :span="24">请假信息</el-col>
					</el-row>
					<div class="form-group m-form__group row">
						<label class="col-xl-2 col-form-label">请假时间：</label>
						<div class="col-xl-4">
							<el-date-picker v-model="form.leavedate" type="daterange" range-separator="至"
								start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
							</el-date-picker>
						</div>
						<label class="col-xl-1 col-form-label">请假天数：</label>
						<div class="col-xl-2">
							<el-input v-model="form.leaveday" disabled></el-input>
						</div>
						<div class="col-xl-2" style="line-height: 30px">
							<span class="m--font-warning">已累计请假天数：{{form.leavedaycount}}天</span>
						</div>
					</div>
					<div class="form-group m-form__group row">
						<label class="col-xl-2 col-form-label">请假原因：</label>
						<div class="col-xl-4">
							<el-input v-model="form.leavereason" placeholder="请输入请假原因"></el-input>
						</div>
					</div>
					<div class="form-group m-form__group row">
						<label class="col-xl-2 col-form-label">请假凭据：</label>
						<div class="col-xl-6" style="text-align: left;vertical-align: middle;">
							<el-upload class="avatar-uploader" ref="upload" :limit="1" :action='uploadUrl'
								:show-file-list="false" :on-success="handleAvatarSuccess"
								:before-upload="beforeAvatarUpload">
								<img v-if="imageUrl" :src="imageUrl" class="avatar">
								<i v-else class="el-icon-plus avatar-uploader-icon"></i>
							</el-upload>
						</div>
					</div>
					<div class="form-group m-form__group row">
						<label class="col-xl-2 col-form-label">请假类型：</label>
						<div class="col-xl-2">
							<el-select v-model="form.leavetype" placeholder="请选择" style="width: 100%;">
								<el-option label="请选择" value=""></el-option>
								<el-option label="非增补" value="0"></el-option>
								<el-option label="补轮转" value="1"></el-option>
							</el-select>
						</div>
					</div>
					<div v-if="form.leavetype != ''">
						<el-row style="font-size: 16px; margin: 15px 30px 0 30px;">
							<el-col :span="24">请假轮转详细</el-col>
						</el-row>
						<div style="margin: 15px 30px 0 30px;">
							<el-table v-loading="leaveloading" :data="form.leaveTableData" stripe style="width: 100%;"
								size="medium">
								<el-table-column prop="CPSecName" label="轮转科室">
								</el-table-column>
								<el-table-column label="请假时间">
									<template slot-scope="scope">
										{{scope.row.BeginDate|formatDate}} - {{scope.row.EndDate|formatDate}}
									</template>
								</el-table-column>
								<el-table-column prop="LeaveDay" label="请假天数">
								</el-table-column>
								<el-table-column label="操作" v-if="form.leavetype == '1'">
									<template slot-scope="scope">
										<el-button @click="AddPlan(scope.row)" type="text" size="medium">新增轮转计划
										</el-button>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</div>
					<div v-if="form.leavetype == '1'">
						<el-row style="font-size: 16px; margin: 15px 30px 0 30px;">
							<el-col :span="24">轮转计划</el-col>
						</el-row>
						<div style="margin: 15px 30px 0 30px;">
							<el-table v-loading="cploading" :data="cpTableData" stripe style="width: 100%;"
								size="medium">
								<el-table-column prop="SecName" label="轮转科室">
								</el-table-column>
								<el-table-column label="开始时间">
									<template slot-scope="scope">
										{{scope.row.CPBeginDate|formatDate}}
									</template>
								</el-table-column>
								<el-table-column label="结束时间">
									<template slot-scope="scope">
										{{scope.row.CPEndDate|formatDate}}
									</template>
								</el-table-column>
							</el-table>
							<el-table :data="form.tableData" stripe style="width: 100%" size="medium"
								:show-header="false" v-if="CPShow == true">
								<el-table-column label="轮转科室">
									<template slot-scope="scope">
										<el-select v-model="scope.row.CPSec" filterable placeholder="请选择">
											<el-option label="请选择" value=""></el-option>
											<el-option v-for="item in cpsecOptions" :key="item.DictItemID"
												:label="item.DictItemName" :value="item.DictItemID">
											</el-option>
										</el-select>
									</template>
								</el-table-column>
								<el-table-column label="开始时间">
									<template slot-scope="scope">
										<el-date-picker v-model="scope.row.CPBeginDate" type="date" placeholder="计划开始时间"
											value-format="yyyy-MM-dd">
										</el-date-picker>
									</template>
								</el-table-column>
								<el-table-column label="结束时间">
									<template slot-scope="scope">
										<el-date-picker v-model="scope.row.CPEndDate" type="date" placeholder="计划结束时间"
											value-format="yyyy-MM-dd">
										</el-date-picker>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</div>
				</div>
				<div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit"
					v-if="form.leavetype == '0' || CPShow == true">
					<div class="m-form__actions m-form__actions--solid">
						<div class="row">
							<div class="col-lg-12 m--align-center">
								<el-button type="success" icon="el-icon-s-order" @click="Save"
									v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
							</div>
						</div>
					</div>
				</div>
			</el-form>
			<el-dialog width="30%" title="添加轮转计划" :visible.sync="planAddVisible">
				<el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed"
					:model="planform" ref="planform">
					<div class="m-portlet__body">
						<div class="form-group m-form__group row">
							<label class="col-xl-4 col-form-label">管理单元：</label>
							<div class="col-xl-6">
								<el-form-item prop="cpsec"
									:rules="{required: true, message: '轮转科室不能为空', trigger: 'blur'}">
									<el-select v-model="planform.managesec" filterable placeholder="请选择"
										@change="AddManageSecChange">
										<el-option label="请选择" value=""></el-option>
										<el-option v-for="item in managesecOptions" :key="item.DictItemID"
											:label="item.DictItemName" :value="item.DictItemID">
										</el-option>
									</el-select>
								</el-form-item>
							</div>
						</div>
						<div class="form-group m-form__group row">
							<label class="col-xl-4 col-form-label">轮转科室：</label>
							<div class="col-xl-6">
								<el-form-item prop="cpsec"
									:rules="{required: true, message: '轮转科室不能为空', trigger: 'blur'}">
									<el-select v-model="planform.cpsec" filterable placeholder="请选择">
										<el-option label="请选择" value=""></el-option>
										<el-option v-for="item in addSecOptions" :key="item.DictItemID"
											:label="item.DictItemName" :value="item.DictItemID">
										</el-option>
									</el-select>
								</el-form-item>
							</div>
						</div>
						<div class="form-group m-form__group row">
							<label class="col-xl-4 col-form-label">开始时间：</label>
							<div class="col-xl-6">
								<el-form-item prop="cpbegindate"
									:rules="{required: true, message: '开始时间不能为空', trigger: 'blur'}">
									<el-date-picker v-model="planform.cpbegindate" type="date" placeholder="计划开始时间"
										value-format="yyyy-MM-dd">
									</el-date-picker>
								</el-form-item>
							</div>
						</div>
						<div class="form-group m-form__group row">
							<label class="col-xl-4 col-form-label">结束时间：</label>
							<div class="col-xl-6">
								<el-form-item prop="cpenddate"
									:rules="{required: true, message: '结束时间不能为空', trigger: 'blur'}">
									<el-date-picker v-model="planform.cpenddate" type="date" placeholder="计划结束时间"
										value-format="yyyy-MM-dd">
									</el-date-picker>
								</el-form-item>
							</div>
						</div>
						<div class="form-group m-form__group row">
							<div class="col-xl-12 m--align-center">
								<el-button type="success" icon="el-icon-s-order" @click="PlanAdd()">新增</el-button>
							</div>
						</div>
					</div>
				</el-form>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'LeaveAdd',
		data() {
			return {
				form: {
					token: '',
					leavesec: '',
					leavestu: '',
					leavedate: '',
					leaveday: '0',
					leavedaycount: '0',
					leavereason: '',
					leaveischangestatus: false,
					leavefile: '',
					secretarysec: '',
					tableData: [],
					leaveTableData: [],
					leavetype: ''
				},
				userid: '',
				username: '',
				rolelevel: '',
				secid: '',
				secOptions: [],
				addSecOptions: [],
				managesecOptions: [],
				cpsecOptions: [],
				stuOptions: [],
				saveUrl: this.$utils.Url.zpgl + '/api/APILeave/Add',
				uploadUrl: this.$utils.Url.zpgl + '/api/APILeave/UploadFile',
				imageUrl: '',
				CPShow: false,
				planAddVisible: false,
				planform: {
					managesec: '',
					cpsec: '',
					cpbegindate: '',
					cpenddate: ''
				},
				condition: {
					token: '',
					stuname: '',
					stuno: ''
				},
				ldloading: false,
				ldTableData: [],
				ldcondition: {
					token: '',
					stuid: '',
					pageSize: 5,
					currentPage: 1,
					recordCount: 0,
					firstSearch: true
				},
				selectstate: false,
				selectstuname: '',
				selectstuno: '',
				selectstumanagesec: '',
				selectstucpsec: '',
				leaveloading: false,
				cploading: false,
				cpTableData: [],
				fullscreenLoading: false,
				endyear: '',
				endmonth: '',
				enddate:''
			}
		},
		filters: {
			formatDate(val) {
				var now = new Date(val)
				var y = now.getFullYear()
				var m = now.getMonth() + 1
				var d = now.getDate()
				return y + '/' + (m < 10 ? '0' + m : m) + '/' + (d < 10 ? '0' + d : d)
			}
		},
		methods: {
			// 调整每页显示数
			ldhandleCurrentChange: function(val) {
				this.ldcondition.firstSearch = false
				this.ldcondition.currentPage = val
				this.LeaveDetailSearch()
			},
			// 分页操作
			ldhandleSizeChange: function(val) {
				this.ldcondition.firstSearch = false
				this.ldcondition.pageSize = val
				this.ldcondition.currentPage = 1
				this.LeaveDetailSearch()
			},
			Save: function() {
				console.log(this.form.leavedate)
				if (this.form.leavedate == '' || this.form.leavedate == null) {
					this.$message({
						message: '请假时间不能为空',
						type: 'warning'
					})
					return
				}

				if (this.form.leavetype == '') {
					this.$message({
						message: '请假类型不能为空',
						type: 'warning'
					})
					return
				}

				this.fullscreenLoading = true

				// if(this.fullscreenLoading == true){
				// 	console.log(this.form)
				// 	return
				// }
				var that = this
				this.$http.post(this.$utils.Url.zpgl + '/api/APILeave/Add', this.form)
					.then(res => {
						if (res.data.Code === 0) {
							that.$message({
								message: '保存成功',
								type: 'success'
							})
							console.log('保存成功')
							that.$router.push('/main/cycle/leave/list')
						} else {
							that.$message({
								message: res.data.Msg + '，' + res.data.Data,
								type: 'error'
							})
						}
						that.fullscreenLoading = false
					})
					.catch(err => {
						console.log(err)
						that.$message({
							message: '保存失败',
							type: 'error'
						})
						that.fullscreenLoading = false
					})
			},
			SearchStu: function() {
				this.stuOptions = []
				var that = this
				this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APILeave/GetLeaveStu', this.condition, function(
					data) {
					that.stuOptions = data.Data
				}, null, null, null)
			},
			StuSelect: function() {
				this.selectstuname = ''
				this.selectstuno = ''
				this.selectstumanagesec = ''
				this.selectstucpsec = ''

				this.ldTableData = []
				this.ldcondition.recordCount = 0

				this.form.leavedate = ''
				this.form.leaveday = '0'
				this.form.leavereason = ''
				this.form.leavefile = ''

				this.form.leavetype = ''

				this.form.leaveTableData = []
				this.cpTableData = []
				this.form.tableData = []
				this.CPShow = false

				this.ldcondition.stuid = this.form.leavestu
				var args = {
					token: this.form.token,
					stuid: this.form.leavestu
				}
				var that = this
				this.$http.post(this.$utils.Url.zpgl + '/api/APILeave/GetStuInfo', args)
					.then(res => {
						if (res.data.Code === 0) {
							that.selectstuname = res.data.Data.StuName
							that.selectstuno = res.data.Data.StuNo
							that.selectstumanagesec = res.data.Data.ManageSecName
							that.selectstucpsec = res.data.Data.SectionName
							that.selectstate = true
							that.LeaveDetailSearch()
							that.GetLastCycle()
						} else {
							that.$message({
								message: res.data.Msg + '，' + res.data.Error,
								type: 'error'
							})
						}
					})
					.catch(err => {
						console.log(err)
						that.$message({
							message: '查询失败',
							type: 'error'
						})
					})
			},
			LeaveDetailSearch: function() {
				this.ldloading = true
				this.ldcondition.currentPage = 1
				var that = this
				this.$http.post(this.$utils.Url.zpgl + '/api/APILeave/GetLeaveDetail', this.ldcondition)
					.then(res => {
						if (res.data.Code === 0) {
							that.ldTableData = res.data.Data
							that.ldcondition.recordCount = res.data.Pager.RecordCount
						} else {
							that.$message({
								message: res.data.Msg + '，' + res.data.Error,
								type: 'error'
							})
						}
						that.ldloading = false
					})
					.catch(err => {
						that.ldTableData = []
						that.ldcondition.recordCount = 0
						console.log(err)
						that.$message({
							message: '查询失败',
							type: 'error'
						})
						that.ldloading = false
					})
			},
			AddPlan: function(row) {
				this.planform.managesec = ''
				this.planform.cpsec = ''
				this.planform.cpbegindate = ''
				this.planform.cpenddate = ''
				console.log(row)

				// this.planform.managesec = parseInt(row.Remark3)
				// this.AddLoadsec()
				// this.planform.cpsec = row.CPSec

				// var begindate = this.endyear + '-' + this.endmonth + '-01'
				// var d = new Date(this.endyear, this.endmonth, 0)
				// var days = d.getDate()

				// if (row.LeaveDay < 28) {
				// 	days = row.LeaveDay
				// }

				// var enddate = this.endyear + '-' + this.endmonth + '-' + days

				this.planform.cpbegindate = this.getNewDay(this.enddate,1)//begindate
				//取当前行的天数
				this.planform.cpenddate = this.getNewDay(this.enddate,row.LeaveDay)//enddate

				this.planAddVisible = true
			},
			PlanAdd: function() {
				var arg = {
					CPID: '0',
					CPSec: this.planform.cpsec,
					CPBeginDate: this.planform.cpbegindate,
					CPEndDate: this.planform.cpenddate
				}
				this.form.tableData.push(arg)
				if ((this.endmonth + 1) > 12) {
					this.endyear = this.endyear + 1
					this.endmonth = 1
				} else {
					this.endmonth = this.endmonth + 1
				}
				console.log(this.form.tableData)
				this.CPShow = true
				this.planAddVisible = false
			},
			LoadCPInfo: function() {
				var args = {
					token: this.form.token,
					stuid: this.form.leavestu,
					leavesec: this.form.leavesec
				}
				this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APICyclePlan/LeaveCPInfo', args, function(data,
					model) {
					model.tableData = data.Data
				}, null, null, this.form)
			},
			LoadLeaveCount: function() {
				var args = {
					stuid: this.form.leavestu,
					token: this.form.token,
					currentPage: 1,
					pageSize: 99999
				}
				this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APILeave/StuLeaveCount', args, function(data,
					model) {
					model.leavedaycount = data.Data
				}, null, null, this.form)
			},
			beforeAvatarUpload: function(file) {
				const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
				if (!isJPG) {
					this.$message.error('上传头像图片只能是 jpg/png 格式!')
				}
				return isJPG
			},
			handleAvatarSuccess: function(res, file) {
				if (res.Code === 0) {
					this.$refs.upload.clearFiles()
					this.imageUrl = URL.createObjectURL(file.raw)
					this.form.leavefile = res.Data
					console.log(res)
				} else {
					this.$message({
						message: res.Msg + '，' + res.Error,
						type: 'error'
					})
				}
			},
			LoadManageSec: function() {
				var args = {
					token: this.form.token,
					username: this.username,
					rolelevel: this.rolelevel
				}
				var that = this
				this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/ManageSecionList', args, function(data) {
					that.managesecOptions = data.Data
				}, null, null, null)
			},
			AddManageSecChange: function() {
				this.planform.cpsec = ''
				this.addSecOptions = []
				this.AddLoadsec()
			},
			AddLoadsec: function() {
				var args = {
					token: this.form.token,
					username: this.username,
					rolelevel: this.rolelevel,
					mamagesec: this.planform.managesec
				}
				var that = this
				this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/CPSecList', args, function(data) {
					that.addSecOptions = data.Data
				}, null, null, null)
			},
			LoadCPSec: function() {
				var args = {
					token: this.form.token,
					username: this.username,
					rolelevel: this.rolelevel,
					mamagesec: ''
				}
				var that = this
				this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/CPSecList', args, function(data) {
					that.cpsecOptions = data.Data
				}, null, null, null)
			},
			ShowLeaveInfo: function(beginDate, endDate) {
				this.leaveloading = true
				var args = {
					token: this.form.token,
					stuid: this.form.leavestu,
					begindate: beginDate,
					enddate: endDate,
				}
				var that = this
				this.$http.post(this.$utils.Url.zpgl + '/api/APILeave/GetLeaveCP', args)
					.then(res => {
						if (res.data.Code === 0) {
							that.form.leaveTableData = []
							that.form.leaveTableData = res.data.Data
							console.log(that.form.leaveTableData)
						} else {
							that.$message({
								message: res.data.Msg + '，' + res.data.Error,
								type: 'error'
							})
						}
						that.leaveloading = false
					})
					.catch(err => {
						that.form.leaveTableData = []
						console.log(err)
						that.$message({
							message: '查询失败',
							type: 'error'
						})
						that.leaveloading = false
					})
			},
			ShowCP: function(endDate) {
				this.cploading = true
				var args = {
					token: this.form.token,
					stuid: this.form.leavestu,
					enddate: endDate,
				}
				var that = this
				this.$http.post(this.$utils.Url.zpgl + '/api/APILeave/GetCP', args)
					.then(res => {
						if (res.data.Code === 0) {
							that.cpTableData = []
							that.cpTableData = res.data.Data
						} else {
							that.$message({
								message: res.data.Msg + '，' + res.data.Error,
								type: 'error'
							})
						}
						that.cploading = false
					})
					.catch(err => {
						that.cpTableData = []
						console.log(err)
						that.$message({
							message: '查询失败',
							type: 'error'
						})
						that.cploading = false
					})
			},
			GetLastCycle: function() {
				var args = {
					token: this.form.token,
					stuid: this.form.leavestu
				}
				var that = this
				this.$http.post(this.$utils.Url.zpgl + '/api/APILeave/GetLastCycleDate', args)
					.then(res => {
						if (res.data.Code === 0) {
							var info = res.data.Data[0]
							this.enddate = new Date(info.CPEndDate)
							// console.log('enddate:' + this.getNewDay(enddate,1))

							// if ((enddate.getMonth() + 2) > 12) {
							// 	that.endyear = enddate.getFullYear() + 1
							// 	that.endmonth = 1
							// } else {
							// 	that.endyear = enddate.getFullYear()
							// 	that.endmonth = enddate.getMonth() + 2
							// }
						}
					})
					.catch(err => {
						console.log(err)
						that.$message({
							message: '查询失败',
							type: 'error'
						})
					})
			},
			getNewDay: function(dateTemp, days) {
				//var dateTemp2 = dateTemp.split("-")
				//转换为MM-DD-YYYY格式
				var nDate = new Date((dateTemp.getMonth()+1) + '-' + dateTemp.getDate() + '-' + dateTemp.getFullYear())
				
				var millSeconds = Math.abs(nDate) + (days * 24 * 60 * 60 * 1000)
				var rDate = new Date(millSeconds)
				var year = rDate.getFullYear()
				var month = rDate.getMonth() + 1
				if (month < 10) month = "0" + month
				var date = rDate.getDate()
				if (date < 10) {
					date = "0" + date
				}
				return (year + "-" + month + "-" + date)
			}
		},
		watch: {
			// 'form.leaveday': function(newValue) {
			//   if (newValue * 1 >= 13) {
			//     this.form.leaveischangestatus = true
			//   } else {
			//     this.form.leaveischangestatus = false
			//   }
			// },
			'form.leavedate': function(newValue) {
				if (newValue != '') {
					var beginDate = newValue[0]
					var endDate = newValue[1]
					var days = new Date(endDate).getTime() / 1000 - parseInt(new Date(beginDate).getTime() / 1000)
					this.form.leaveday = parseInt(days / 60 / 60 / 24) + 1

					this.ShowLeaveInfo(beginDate, endDate)
					this.ShowCP(endDate)
				}
			}
		},
		mounted: function() {
			this.ldcondition.token = sessionStorage.getItem('token')
			this.condition.token = sessionStorage.getItem('token')
			this.form.token = sessionStorage.getItem('token')
			this.userid = sessionStorage.getItem('userid')
			this.username = sessionStorage.getItem('username')
			this.rolelevel = sessionStorage.getItem('rolelevel')
			this.secid = sessionStorage.getItem('secid')
			this.LoadManageSec()
			this.LoadCPSec()
		}
	}
</script>

<style scoped="scoped">
	.el-form-item {
		margin-bottom: 0px;
	}

	.el-select {
		width: 100%;
	}

	.el-date-editor.el-input,
	.el-date-editor.el-input__inner {
		width: 100%;
	}

	.m-form.m-form--group-seperator-dashed .m-form__group {
		border-bottom: 0;
	}

	/deep/.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
</style>
